module.exports = __webpack_public_path__ + "static/media/profile_blank.84a4605d.png";